import BroadcastBlacklistAPI from '../../api/broadcastBlacklist';

const state = () => ({
  entries: [],
  loading: false,
  total: 0,
});

const getters = {
  list(_state) {
    return _state.entries;
  },
  count(_state) {
    return _state.total;
  },
  isLoading(_state) {
    return _state.loading;
  },
};

const mutations = {
  SET_ENTRIES(_state, { entries, total }) {
    _state.entries = entries;
    _state.total = total;
  },
  ADD_ENTRY(_state, entry) {
    _state.entries.unshift(entry);
    _state.total += 1;
  },
  REMOVE_ENTRY(_state, id) {
    _state.entries = _state.entries.filter(e => e.id !== id);
    _state.total = Math.max(0, _state.total - 1);
  },
  SET_LOADING(_state, value) {
    _state.loading = value;
  },
};

const actions = {
  async list({ commit }, params = {}) {
    commit('SET_LOADING', true);
    try {
      const response = await BroadcastBlacklistAPI.get(params);
      const data = response.data;
      commit('SET_ENTRIES', {
        entries: data.payload || data || [],
        total: data.meta?.count ?? (data.payload || data || []).length,
      });
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async create({ commit }, payload) {
    const response = await BroadcastBlacklistAPI.create(payload);
    commit('ADD_ENTRY', response.data);
    return response.data;
  },

  async destroy({ commit }, id) {
    await BroadcastBlacklistAPI.delete(id);
    commit('REMOVE_ENTRY', id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
